/**
 * Enforces node consistency on the problem instance
 * @param {*} problemInstance The problem instance you would like node consistency enforced on
 * @returns The node consistent problemInstance
 */
export function nodeConsistency(problemInstance) {
  const {
    constraints, variables, intervals, taskIntervalMap,
  } = problemInstance;
  let vars = null;
  constraints.forEach(con => {
    vars = con.variables;
    if (vars.length === 1) {
      const { currentDomain } = vars[0];
      const variableTask = vars[0].varRef.task;
      if (con.name.includes('pref')) {
        const tp = problemInstance.taskPreferences.filter(element => element.task_id === variableTask.id);
        for (let i = currentDomain.length - 1; i >= 0; i--) {
          const d = currentDomain[i];
          const pref = tp.find(element => element.status_id === d.status.id);
          if (!con.definition(d, pref)) {
            currentDomain.splice(i, 1);
          }
        }
      } else if (con.name.includes('vol')) {
        for (let i = currentDomain.length - 1; i >= 0; i--) {
          const d = currentDomain[i];
          if (!con.definition(d, variableTask.name)) {
            currentDomain.splice(i, 1);
          }
        }
      } else {
        for (let i = currentDomain.length - 1; i >= 0; i--) {
          const d = currentDomain[i];
          if (!con.definition(variableTask, d)) {
            currentDomain.splice(i, 1);
          }
        }
      }
    }
  });

  const tasks = variables.filter(element => element.variableName.includes('-0'));
  tasks.forEach(task => {
    const name = task.variableName.split('-0')[0];
    const ints = taskIntervalMap[name];
    ints.forEach(interval => {
      intervals[interval].tasks[name].domain = task.currentDomain.length;
    });
  });

  return problemInstance;
}

/**
 * Enforces node consistency on the problem instance for branch and bound
 * @param {*} problemInstance The problem instance you would like node consistency enforced on
 * @returns The node consistent problemInstance
 */
export function nodeConsistencyBB(problemInstance) {
  const {
    constraints, variables, intervals, taskIntervalMap,
  } = problemInstance;
  let vars = null;
  constraints.forEach((con) => {
    vars = con.variables;
    if (vars.length === 1) {
      // console.log(vars[0]);
      const { currentDomain } = vars[0];
      const variableTask = vars[0].varRef.task;
      if (con.name.includes('pref')) {
        const tp = problemInstance.taskPreferences.filter(element => element.task_id === variableTask.id);
        currentDomain.applicants.forEach((applicant) => {
          const pref = tp.find(element => element.status_id === applicant.status.id);
          if (!con.definition(applicant, pref)) {
            currentDomain.removeApplicant(applicant);
          }
        });
      } else {
        currentDomain.applicants.forEach((applicant) => {
          if (!con.definition(variableTask, applicant)) {
            currentDomain.removeApplicant(applicant);
          }
        });
      }
    }
  });

  const tasks = variables.filter(element => element.variableName.includes('-0'));
  tasks.forEach(task => {
    const name = task.variableName.split('-0')[0];
    const ints = taskIntervalMap[name];
    ints.forEach(interval => {
      intervals[interval].tasks[name].domain = task.currentDomain.getActiveApplicants().length;
    });
  });

  return problemInstance;
}
